import { createTheme } from '@mui/material/styles';

/** Skyrover brand magenta */
export const SKYROVER_BRAND = '#990099';
export const SKYROVER_BRAND_DARK = '#770077';
export const SKYROVER_BRAND_LIGHT = '#AD00AD';
export const SKYROVER_BRAND_MUTED = 'rgba(153, 0, 153, 0.12)';

/** Skyrover brand theme */
export const skyroverTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: SKYROVER_BRAND,
      dark: SKYROVER_BRAND_DARK,
      light: SKYROVER_BRAND_LIGHT,
      contrastText: '#ffffff',
    },
    secondary: {
      main: SKYROVER_BRAND_LIGHT,
      contrastText: '#ffffff',
    },
    background: {
      default: '#ECECEC',
      paper: '#FFFFFF',
    },
    divider: '#D8D8D8',
    text: {
      primary: '#2D2D2D',
      secondary: '#666666',
    },
    success: {
      main: '#2E7D32',
      light: '#E8F5E9',
    },
    info: {
      main: SKYROVER_BRAND,
      light: '#F9E6F9',
    },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif',
    fontSize: 13,
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { overflow: 'hidden', margin: 0 },
        '#root': { height: '100vh', width: '100vw' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 20, boxShadow: 'none' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 36,
          textTransform: 'none',
          fontWeight: 600,
          fontSize: 12,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          bgcolor: SKYROVER_BRAND_MUTED,
        },
        bar: {
          bgcolor: SKYROVER_BRAND,
        },
      },
    },
  },
});

export const SKYROVER_COLORS = {
  header: SKYROVER_BRAND,
  headerHover: SKYROVER_BRAND_LIGHT,
  brand: SKYROVER_BRAND,
  brandDark: SKYROVER_BRAND_DARK,
  brandLight: SKYROVER_BRAND_LIGHT,
  brandMuted: SKYROVER_BRAND_MUTED,
  toolbox: '#ECECEC',
  workspace: '#FFFFFF',
  rightPanel: '#F5F5F5',
  pillBg: 'rgba(255,255,255,0.15)',
  pillBorder: 'rgba(255,255,255,0.25)',
} as const;
